import { getVersion, setWorkerUrl } from 'maplibre-gl'

let initialized = false

/**
 * MapLibre GL JS v6 の Web Worker の URL を public/ 配下の自前配信に向ける。
 * 2回呼び出されても1回だけ設定する（冪等）。
 *
 * v6 の Worker は同ディレクトリの maplibre-gl-shared.mjs を相対 import するが、Next.js は両ファイルを
 * 個別のハッシュ付きアセットとして出力するため、Worker 内の `./maplibre-gl-shared.mjs` が解決できず
 * 「Worker failed to load」となり地図が描画されない。そのため scripts/sync-maplibre-worker.cjs で
 * 両ファイルを public/maplibre/{version}/ に元のファイル名で配置し、ここで明示的に指す。
 * ディレクトリをバージョンで分けるのは、ブラウザキャッシュに残った旧 Worker と新しいメインバンドルの
 * 組み合わせ不一致を防ぐため（Lambda@Edge 側も /maplibre/** を静的ファイルとして rootDir 直下へ書き換える）。
 *
 * 使用方法:
 * ```
 * // pages/_app.tsx（モジュールトップレベル、initPmtilesProtocol と同様）
 * import { initMaplibreWorker } from '@/lib/map/initMaplibreWorker'
 * initMaplibreWorker()
 * ```
 */
export function initMaplibreWorker(): void {
  if (initialized || typeof window === 'undefined') return
  setWorkerUrl(`/maplibre/${getVersion()}/maplibre-gl-worker.mjs`)
  initialized = true
}
